document.addEventListener("DOMContentLoaded", function(){
  setXSellFn();
  document.addEventListener('rerender_cart_event', ()=>{
    console.log("rerender cart event ");
    setXSellFn();
  });
  function setXSellFn(){
    var cart_add_btn = document.querySelector('.cart_add_btn_x_sell');
    if( cart_add_btn ){
      console.log("cart_add_btn_x_sell: ",cart_add_btn);
      var variant_id = cart_add_btn.getAttribute('data-variant-id');
      var pfand = cart_add_btn.getAttribute('data-pfand');
      console.log("cart_add_btn_x_sell: ",cart_add_btn, " variant_id: ",variant_id);

      cart_add_btn.addEventListener("click", () => {
          console.log("clicked element", cart_add_btn, pfand);
          addXSellProductToCart(variant_id, pfand);
      });
    }
  }

  function addXSellProductToCart(variant, pfand = null){
    console.log('pfand ', pfand)
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    console.log("addFreeGiftsToCart",variant);
    let formData = {
    'items': [{
      'id': variant,
      'quantity': 1
      }]
    };
    if(pfand != null){
      var pfand_key = parseInt(pfand) + "-" + Math.random().toString(16).slice(2);
      //update current
      formData.items[0]['properties']={};
      formData.items[0]['properties']['_pfand_key'] = pfand_key;
      //new item
      var item = {
        'id': window.theme.pfand_product,
        'quantity': parseInt(pfand_key) //assuing qty is always 1
      };
      item['properties']={};
      item['properties']['_pfand_key'] =pfand_key;
      formData.items.unshift(item);

    }
    fetch(window.routes.cartUrl + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});